  
 
  <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
        Add Category Name
        <button mat-icon-button (click)="closeAddCategory()">
        <mat-icon>close</mat-icon>
        </button>
    </h2>
    
  <mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width">
        <mat-label>Category Name</mat-label>
        <input matInput maxlength="30" [required]="true"  placeholder="Add category name" formControlName="categoryname"/>
        <mat-error
        *ngIf="formDialog.get('categoryname').invalid &&
          (formDialog.get('categoryname').dirty ||
          formDialog.get('categoryname').touched)">
        <span>This field is mandatory.</span>
      </mat-error>
      </mat-form-field> 
  
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closeAddCategory()">Cancel</button>
    <button mat-flat-button color="primary"    
    [disabled]="formDialog.invalid || !formDialog.dirty"
    (click)="AddCategoryName(formDialog.value)">Save
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions>
  
    </form>
  

  




